<div class="row provision">
  <div class="col-lg-12">
    <div class="grid">
      <div class="item-wrapper">
        <table class="table table-responsive" *ngIf="devices.length">
          <thead>
            <th>MAC</th>
            <th>Name</th>
            <th>Org
              <select [(ngModel)]="bulkOrgID" class="form-control ng-pristine ng-valid ng-touched table-header-select" name="bulkOrgID" (ngModelChange)="bulkChange('org_id', $event)">
                <option *ngFor="let subOrg of organizationService.subOrgs" [value]="subOrg.id">
                  {{subOrg.name}}
                </option>
              </select>
            </th>
            <th>Site
              <select [(ngModel)]="bulkLocationID" class="form-control ng-pristine ng-valid ng-touched table-header-select" name="bulkLocationID" (ngModelChange)="bulkChange('location_id', $event)">
                <option *ngFor="let location of locationService.locations | locationOrgFilter:bulkOrgID" [value]="location.id">
                  {{location.company}}
                </option>
              </select>
            </th>
            <th></th>
          </thead>
          <tbody>
            <tr *ngFor="let device of devices">
              <td width="10%">{{device.code}}</td>
              <td><input type="text" class="form-control" [(ngModel)]="device.name" /></td>
              <td class="select-cell">
                <select [(ngModel)]="device.org_id" class="form-control ng-pristine ng-valid ng-touched" name="org_id" required="">
                  <option *ngFor="let subOrg of organizationService.subOrgs" [value]="subOrg.id">
                    {{subOrg.name}}
                  </option>
                </select>
              </td>
              <td class="select-cell">
                <select [(ngModel)]="device.location_id" class="form-control ng-pristine ng-valid ng-touched" name="location_id" required="">
                  <option *ngFor="let location of locationService.locations | locationOrgFilter:device.org_id" [value]="location.id">
                    {{location.company}}
                  </option>
                </select>
              </td>
              <td><button type="button" class="btn btn-primary" (click)="saveDevice(device)">Save</button></td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</div>
